import {convertHydraObjectToArray} from '@/helper/ArrayHelper';
export default {
  methods: {
    prepareGender(value) {
      let gender;
      switch (value) {
        case 'gender.male':
          gender = 'm';
          break;
        case 'gender.female':
          gender = 'f';
          break;
        case 'gender.other':
          gender = 'd';
          break;
      }
      return gender;
    },
    convertFilterParamsToTypesense(fullFilterParams) {
      fullFilterParams = new URLSearchParams(fullFilterParams);

      function addFilterBy(key, value) {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            key +
            ':=' +
            '[' +
            value.join(',') +
            ']'
        );
      }

      function addFilterByStarredCompanies(key, value) {
        const valueArray = Object.values(value);
        const companies = [];
        valueArray.map((item) => {
          if (typeof item === 'string') {
            companies.push(item);
          }
        });
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            key +
            ':=' +
            '[' +
            companies +
            ']'
        );
      }

      function addFilterByLocation(location) {
        const lat = location.split(',')[0];
        const long = location.split(',')[1];
        const dis = location.split(',')[2] / 1000 + 'km';
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            '(locations:(' +
            lat +
            ',' +
            long +
            ',' +
            dis +
            ')||is_nation_wide:=true)'
        );
      }

      function addFilterByCustom(type, operation, value) {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            type +
            operation +
            value
        );
      }

      function addFilterByCreated(interval) {
        const date = new Date();
        const dateTimeInSeconds = Math.floor(date.getTime() / 1000);
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            'created' +
            ':>=' +
            (dateTimeInSeconds - interval)
        );
      }

      function addFilterByCreatedInPast(interval) {
        const date = new Date();
        const dateTimeInSeconds = Math.floor(date.getTime() / 1000);
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            'created' +
            ':<=' +
            (dateTimeInSeconds - interval)
        );
      }

      function addFilterByBetween(keyMin, keyMax, min, max) {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            keyMin +
            ':<' +
            min +
            '&&' +
            keyMax +
            ' :>' +
            max
        );
      }

      function addFilterByEqual(key, value) {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            key +
            ':=' +
            value
        );
      }

      function addFilterByTopOffers() {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') +
            'sum_applications:>=5 && sum_views:>=100 && sum_coins:>=100 && budget_cluster:>=5'
        );
      }

      function addFilterByOpportunities() {
        convertedParameters.set(
          'filter_by',
          (convertedParameters.has('filter_by')
            ? convertedParameters.get('filter_by') + ' && '
            : '') + 'sum_applications:<6'
        );
      }

      const convertedParameters = new URLSearchParams();
      convertedParameters.set('q', '*');
      if (fullFilterParams.has('search'))
        convertedParameters.set('q', fullFilterParams.get('search'));

      if (fullFilterParams.has('distance'))
        addFilterByLocation(fullFilterParams.get('distance'));

      if (fullFilterParams.has('activity[]'))
        addFilterBy('activity', fullFilterParams.getAll('activity[]'));

      if (fullFilterParams.has('industry[]'))
        addFilterBy('industry', fullFilterParams.getAll('industry[]'));

      if (fullFilterParams.has('employmentTypesOr[]'))
        addFilterBy(
          'employment_types',
          fullFilterParams.getAll('employmentTypesOr[]')
        );

      if (fullFilterParams.has('tagsOr[]'))
        addFilterBy('tags', fullFilterParams.getAll('tagsOr[]'));

      if (fullFilterParams.has('job_id[]'))
        addFilterBy('job_id', fullFilterParams.getAll('job_id[]'));

      // Date
      if (fullFilterParams.has('datePeriodStart'))
        addFilterByCustom(
          'date_start',
          ':>=',
          Math.floor(
            new Date(fullFilterParams.get('datePeriodStart')).getTime() / 1000
          )
        );

      if (fullFilterParams.has('datePeriodEnd'))
        addFilterByCustom(
          'date_end',
          ':<=',
          Math.floor(
            new Date(fullFilterParams.get('datePeriodEnd')).getTime() / 1000
          ) + 86340
        );
      //Start
      if (fullFilterParams.has('dateStartFromNow'))
        addFilterByEqual('start_immediately', true);
      if (fullFilterParams.has('dateOpenEnded'))
        addFilterByEqual('open_ended', true);
      //Salary
      if (fullFilterParams.has('salary[min]'))
        addFilterByCustom(
          'salary_value',
          ':>=',
          fullFilterParams.get('salary[min]')
        );

      if (fullFilterParams.has('salary[type]'))
        addFilterByCustom(
          'salary_type',
          ':=',
          fullFilterParams.get('salary[type]')
        );
      //Age
      if (
        fullFilterParams.has('age') &&
        this.$auth.user.candidateProfile.birthDate
      )
        addFilterByBetween(
          'min_age',
          'max_age',
          this.currentAge(),
          this.currentAge()
        );
      //Body Height
      if (
        fullFilterParams.has('bodyHeight') &&
        this.$auth.user.candidateProfile.bodyHeight
      )
        addFilterByBetween(
          'min_body_height',
          'max_body_height',
          this.$auth.user.candidateProfile.bodyHeight,
          this.$auth.user.candidateProfile.bodyHeight
        );
      //Gender
      if (
        fullFilterParams.has('gender') &&
        this.$auth.loggedIn &&
        this.$auth.user.candidateProfile.gender
      )
        addFilterByEqual(
          'preferred_gender',
          this.prepareGender(this.$auth.user.candidateProfile.gender)
        );
      if (fullFilterParams.has('gender') && !this.$auth.loggedIn)
        addFilterByEqual('preferred_gender', fullFilterParams.get('gender'));
      //Starred companies
      if (fullFilterParams.has('my_favoritesOnly')) {
        addFilterByStarredCompanies(
          'organization_id',
          this.$auth.user.starredCompanyIds
        );
      }
      //Release period
      if (fullFilterParams.has('created')) {
        addFilterByCreated(fullFilterParams.get('created'));
      }
      if (
        fullFilterParams.get('additionalFilters') &&
        fullFilterParams.get('additionalFilters') === 'top-offers'
      ) {
        addFilterByTopOffers();
      }
      if (
        fullFilterParams.get('additionalFilters') &&
        fullFilterParams.get('additionalFilters') === 'opportunities'
      ) {
        addFilterByOpportunities();
        addFilterByCreatedInPast('864000');
      }

      return convertedParameters;
    },
    currentAge() {
      const today = new Date();
      const birthDate = new Date(this.$auth.user.candidateProfile.birthDate);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  computed: {
    filterParamsWithMyFilters() {
      const filterParamsObject = new URLSearchParams(this.filterParams);

      if (filterParamsObject.has('my_age')) {
        filterParamsObject.delete('my_age');
        if (this.$auth.user.candidateProfile.birthDate) {
          const now = new Date();
          const birthdate = new Date(
            this.$auth.user.candidateProfile.birthDate
          );
          const age = Math.floor(
            Math.abs(birthdate - now) / (1000 * 3600 * 24 * 365)
          );
          filterParamsObject.set('age', age.toString());
        }
      }

      if (filterParamsObject.has('my_bodyHeight')) {
        filterParamsObject.delete('my_bodyHeight');
        if (this.$auth.user.candidateProfile.bodyHeight) {
          filterParamsObject.set(
            'bodyHeight',
            this.$auth.user.candidateProfile.bodyHeight
          );
        }
      }

      if (filterParamsObject.has('my_gender')) {
        filterParamsObject.delete('my_gender');
        let gender;
        switch (this.$auth.user.candidateProfile.gender) {
          case 'gender.male':
            gender = 'm';
            break;
          case 'gender.female':
            gender = 'f';
            break;
          case 'gender.other':
            gender = 'd';
            break;
        }
        if (gender) {
          filterParamsObject.set('gender', gender);
        }
      }

      if (filterParamsObject.has('my_preferredActivities')) {
        filterParamsObject.delete('my_preferredActivities');
        for (const activity_key in convertHydraObjectToArray(
          this.$auth.user.candidateProfile.preferredActivities
        )) {
          filterParamsObject.append(
            'activity[]',
            this.$auth.user.candidateProfile.preferredActivities[activity_key]
          );
        }
      }

      if (filterParamsObject.has('my_preferredIndustries')) {
        filterParamsObject.delete('my_preferredIndustries');
        for (const industry_key in convertHydraObjectToArray(
          this.$auth.user.candidateProfile.preferredIndustries
        )) {
          filterParamsObject.append(
            'industry[]',
            this.$auth.user.candidateProfile.preferredIndustries[industry_key]
          );
        }
      }

      return filterParamsObject.toString();
    },
  },
};
